import {allContactsLoaded,ALL_CONTACTS_LOADED} from '../../actions/contacts/refresh-all-contacts';
import {CONTACT_SAVED, ContactSavedAction} from '../../actions/contacts/save-contact';
import { ActionType } from 'typesafe-actions';
import { Contact } from '../../../types/listing/contact';

export type CurrentListingLoadedAction = ActionType<typeof allContactsLoaded>;

type AllContactsAction = CurrentListingLoadedAction | ContactSavedAction;

export default(state: Contact[] = [], action: AllContactsAction) => {
    switch(action.type){
        case ALL_CONTACTS_LOADED:
            return [...action.payload];
        break;
        case CONTACT_SAVED:
            const savedContact: Contact = action.payload;
            const existingIndex = state.findIndex(c => c.contactId === savedContact.contactId);
            
            if (existingIndex >= 0) {
                const newState = state.slice();
                newState[existingIndex] = savedContact;
                return newState;
            } else {
                return state.concat([savedContact]);
            }
        default:
            return state;
    }
}